import { CustomButton, Modal } from '@ui-kit'
import React, { useState } from 'react'
import EPRQueryModal from './ERPQueryModal'
import { FieldValues } from 'react-hook-form'
import { NAMESPACES } from '../../utils/constants'

const EPRQueryButton: React.FC<{
  patientData: FieldValues
  metaData: { layout_id: string; entity_id: string; entity_name: string }
  pharmacyEntityName?: string
  disabled?: boolean
  onHybridSignal?: () => void
  buttonText?: string
  distributor?: string
}> = ({
  patientData,
  metaData,
  disabled,
  pharmacyEntityName,
  onHybridSignal,
  buttonText,
  distributor,
}) => {
  const [queryModalVisible, setQueryModalVisible] = useState<boolean>(false)

  return (
    <>
      <CustomButton
        onClick={() =>
          onHybridSignal ? onHybridSignal() : setQueryModalVisible(true)
        }
        isFilled
        disabled={disabled}
      >
        <span>{buttonText ?? NAMESPACES.EPR_PATIENT_REQUEST}</span>
      </CustomButton>
      {queryModalVisible ? (
        <Modal
          isOpen={queryModalVisible}
          closeModal={() => {
            setQueryModalVisible(false)
          }}
          isDragable
          isBackdropInteractive
          isResizable
          minResizeHeight={310}
          minResizeWidth={430}
          width="w-[min(60rem,calc(100vw-2rem))] max-w-[60rem]"
          bodyCssClassName="!flex !flex-col !overflow-hidden [&_.modal-scroll-container]:!flex-1 [&_.modal-scroll-container]:!min-h-0 [&_.modal-scroll-container]:!overflow-hidden [&_.modal-body-container]:!h-full [&_.modal-body-container]:!min-h-0"
        >
          <EPRQueryModal
            patientData={patientData}
            metaData={metaData}
            closeModal={() => setQueryModalVisible(false)}
            pharmacyEntityName={pharmacyEntityName}
            distributor={distributor ?? ''}
          />
        </Modal>
      ) : null}
    </>
  )
}

export default EPRQueryButton
